var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStartTreatmentStep = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 159 159"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "start-treatment-step_svg__a",
  width: 159,
  height: 159,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 79.5,
  r: 79.5,
  fill: "#000"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#start-treatment-step_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 80.106,
  r: 78.5,
  fill: "#fff",
  stroke: "#5472CC",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  fill: "#5472CC",
  "data-figma-bg-blur-radius": 3.714
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.24,
  d: "M78.953 29.294c10.008 0 19.108 1.182 25.736 3.116 3.308.964 6.057 2.133 8.002 3.474 1.915 1.32 3.262 2.963 3.262 4.91 0 1.393-.059 2.867.118 4.248q.048.379.049.771v67.488l-.002.17c-.041 1.463-.155 2.966-.031 4.423q.034.395.034.794c0 10.23-16.585 18.522-37.045 18.522s-37.046-8.292-37.046-18.522q0-.187.008-.373c.06-1.516-.13-3.071-.238-4.585a6 6 0 0 1-.015-.429V45.813q0-.393.05-.773c.176-1.38.118-2.854.118-4.246 0-1.947 1.347-3.59 3.262-4.91 1.945-1.341 4.694-2.51 8.002-3.474 6.629-1.934 15.728-3.116 25.736-3.116"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.953 29.294v-1zm25.736 3.116.28-.96zm8.002 3.474.568-.823zm3.262 4.91h1zm.167 5.019h1zm0 67.488h1zm.001 5.387h1zM79.076 137.21v1zM42.03 118.688h-1zm-.245-5.387h-1zm0-67.488h-1zm.168-5.019h-1zm3.262-4.91-.568-.823zm8.002-3.474-.28-.96zm62.901 81.061-1-.028zm-.031 4.423-.996.085zm-.016-72.852-.992.127zM78.953 29.294v1c9.941 0 18.942 1.176 25.456 3.076l.28-.96.28-.96c-6.742-1.967-15.94-3.155-26.016-3.156zm25.736 3.116-.28.96c3.257.95 5.893 2.081 7.715 3.338l.567-.824.568-.823c-2.069-1.427-4.932-2.632-8.29-3.611zm8.002 3.474-.567.824c1.823 1.257 2.829 2.638 2.829 4.087h2c0-2.447-1.689-4.351-3.694-5.734zm3.38 9.158-.992.127q.04.315.041.644h2q0-.456-.057-.898zm.049.771h-1v67.488h2V45.813zm0 67.488h-1l-.002.142 1 .028.999.028q.003-.097.003-.198zm-.033 4.593-.996.085q.03.353.03.709h2q0-.441-.037-.879zm.034.794h-1c0 4.532-3.7 8.904-10.297 12.203-6.538 3.269-15.64 5.319-25.748 5.319v2c10.351 0 19.772-2.095 26.642-5.53 6.81-3.405 11.403-8.294 11.403-13.992zM79.076 137.21v-1c-10.108 0-19.21-2.05-25.748-5.319-6.598-3.299-10.298-7.671-10.298-12.203h-2c0 5.698 4.593 10.587 11.404 13.992 6.87 3.435 16.29 5.53 26.642 5.53zM42.03 118.688h1q0-.166.007-.333l-1-.04-.998-.04q-.009.206-.009.413zm-.23-4.958.998-.07a5 5 0 0 1-.013-.359h-2q0 .252.018.5zm-.015-.429h1V45.813h-2v67.488zm0-67.488h1q0-.33.041-.646l-.992-.127-.992-.127a7 7 0 0 0-.057.9zm.168-5.019h1c0-1.448 1.006-2.83 2.83-4.086l-.568-.824-.568-.823c-2.005 1.383-3.694 3.287-3.694 5.733zm3.262-4.91.567.824c1.822-1.257 4.458-2.388 7.715-3.338l-.28-.96-.28-.96c-3.358.98-6.221 2.185-8.29 3.611zm8.002-3.474.28.96c6.514-1.9 15.515-3.076 25.456-3.076v-2c-10.075 0-19.273 1.19-26.016 3.156zm-11.18 85.905 1 .04c.063-1.59-.137-3.253-.24-4.695l-.997.07-.997.071c.112 1.584.293 3.032.236 4.474zm74.081-4.844-1-.028c-.039 1.397-.158 3.003-.027 4.536l.996-.085.997-.085c-.118-1.382-.009-2.781.033-4.31zM41.834 45.04l.992.127c.188-1.463.127-3.04.127-4.373h-2c0 1.45.056 2.822-.11 4.119zm74.119-4.246h-1c0 1.333-.062 2.911.126 4.376l.992-.128.992-.127c-.167-1.297-.11-2.67-.11-4.12z"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 78.954,
  cy: 39.795,
  fill: "#5472CC",
  fillOpacity: 0.24,
  stroke: "#5472CC",
  strokeWidth: 2,
  "data-figma-bg-blur-radius": 3.714,
  rx: 36.923,
  ry: 10.795
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472CC",
  strokeWidth: 2,
  d: "M108.762 57.188c1.269 1.007 1.963 2.096 1.963 3.233 0 5.149-14.224 9.323-31.77 9.323-17.547 0-31.771-4.174-31.771-9.323 0-1.136.693-2.226 1.962-3.233",
  "data-figma-bg-blur-radius": 3.714
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472CC",
  strokeWidth: 2,
  d: "M108.76 57.968c0 4.877-13.345 8.832-29.808 8.832-16.462 0-29.807-3.954-29.807-8.832M108.76 57.968v-6.379c0-4.877-13.345-8.832-29.808-8.832-16.462 0-29.807 3.955-29.807 8.832v6.379",
  "data-figma-bg-blur-radius": 3.714
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472CC",
  strokeWidth: 2,
  d: "M115.876 66.8c0 5.962-16.53 10.794-36.922 10.794S42.03 72.762 42.03 66.8",
  "data-figma-bg-blur-radius": 3.714
}))));
export default SvgStartTreatmentStep;